import { render, staticRenderFns } from "./SeasonList.vue?vue&type=template&id=60c12998&scoped=true"
import script from "./SeasonList.vue?vue&type=script&lang=js"
export * from "./SeasonList.vue?vue&type=script&lang=js"
import style0 from "./SeasonList.vue?vue&type=style&index=0&id=60c12998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c12998",
  null
  
)

export default component.exports